import { APP_ROUTES } from ".";

export const APP_CONFIG = {
  LOCAL_STORAGE_KEYS: {
    TOKEN: "wisere-access-key",
  },
  FALLBACK_ROUTE: APP_ROUTES.ORDER.BASE,
};

export enum APP_MODULES {
  POST,
  AGENT,
  DOCUMENT,
  PAGE,
  QUOTATION,
  SALES,
  CUSTOMER,
  RESOURCE,
  CONTENT,
}

export const APP_MAPPING_PERMISSIONS: { [email: string]: APP_MODULES[] } = {
  "midomsamdua.sale@gmail.com": [APP_MODULES.SALES, APP_MODULES.CUSTOMER],
  "sales@midomsamdua.com": [APP_MODULES.SALES, APP_MODULES.CUSTOMER],
  "midomsamdua.content@gmail.com": [APP_MODULES.CONTENT],
};
